import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

@Injectable({
    providedIn: 'root'
})
export class IntrocardService {
    constructor(
        private http: HttpClient,
    ) { }

    get(): Observable<introcardGetResponse> {
        return this.http.post<introcardGetResponse>(`${environment.apiUrl}introcard`, {});
    }

    purchaseCredits(quantity: number): Observable<introcardPurchaseCreditsResponse> {
        return this.http.post<introcardPurchaseCreditsResponse>(`${environment.apiUrl}introcard/purchase_credits`, {
            quantity: quantity,
        });
    }
}

export interface introcardGetResponse {
    barcode: string;
    credits: number;
    purchasable_credits: number;
    ticket_price?: number;
    current_in_scans: {
        token: string;
        scanned_at: string;
    }[];
}

export interface introcardPurchaseCreditsResponse {
    transaction_id: number;
    payment_url: string;
}
